import React from 'react';
import Layout from '../../../components/Layout';
import HeadMessage from '../../../components/Common/HeadMessage/HeadMessage';
import Breadcrumbs from '../../../components/Breadcrumbs';
import WidgetPage from './WidgetPage';
import { getWidget } from '../../../data/widgets';
import { isReleased } from '../../../data/widgets/release';
import {
	breadcrumbSchema,
	canonicalUrl,
	SITE_URL,
	CHROME_STORE_URL,
} from '../../../utils/seo';

/**
 * /widgets/:slug — лендинг одного виджета.
 *
 * Неизвестный slug отдаёт 404, а не мягкую заглушку: иначе получаем soft 404
 * на бесконечном числе URL.
 */
function action({ params }) {
	const widget = getWidget(params.slug);

	if (!widget) {
		return undefined; // провалится в wildcard-роут not-found
	}

	// Страница из очереди поэтапной публикации до своей даты не существует
	// вовсе: честный 404, как у несуществующего slug. Не «доступна, но с
	// noindex» — робот, добравшийся до неё по любому пути, не должен получить
	// ничего, кроме 404. @see src/data/widgets/release.js
	if (!isReleased(widget.slug)) {
		return undefined;
	}

	const url = `/widgets/${widget.slug}`;

	return {
		title: widget.title,
		description: widget.metaDescription,
		chunks: ['widget-page'],
		ogImage: widget.screenshot
			? `${SITE_URL}/img/widgets/${widget.screenshot.file}`
			: undefined,
		jsonLd: [
			{
				'@context': 'https://schema.org',
				'@type': 'WebPage',
				'@id': `${canonicalUrl(url)}#webpage`,
				url: canonicalUrl(url),
				name: widget.title,
				description: widget.metaDescription,
				isPartOf: { '@id': `${SITE_URL}/#website` },
				primaryImageOfPage: widget.screenshot
					? `${SITE_URL}/img/widgets/${widget.screenshot.file}`
					: undefined,
				about: {
					'@type': 'SoftwareApplication',
					name: 'New Tab Studio: Countdown & widgets',
					applicationCategory: 'BrowserApplication',
					operatingSystem: 'Chrome, Edge, Opera, Brave, Vivaldi',
					installUrl: CHROME_STORE_URL,
					featureList: widget.name,
				},
			},
			breadcrumbSchema([
				{ name: 'Home', url: '/' },
				{ name: 'Widgets', url: '/widgets' },
				{ name: widget.name, url },
			]),
		],
		component: (
			<Layout>
				<Breadcrumbs
					items={[
						{ name: 'Home', url: '/' },
						{ name: 'Widgets', url: '/widgets' },
						{ name: widget.name },
					]}
				/>

				<HeadMessage variant="compact">
					<h1>{widget.h1}</h1>
				</HeadMessage>

				<WidgetPage widget={widget} />
			</Layout>
		),
	};
}

export default action;
